import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "../Pages/Auth/Login";
import AppLayout from "../Layouts/AppLayout";
import Main from "../Pages/Main/Main";
import ProtectedRoute from "./ProtectedRoute";

import EditProfile from "../Pages/Profile/EditProfile";

import Dashboard from "../Pages/Dashboard/Dashboard";
import Feedbacks from "../Pages/Dashboard/Feedbacks";

import Admins from "../Pages/Admins/Admins";
import AddAdmin from "../Pages/Admins/AddAdmin";
import EditAdmin from "../Pages/Admins/EditAdmin";
import AdminProfile from "../Pages/Admins/AdminProfile";

import Brands from "../Pages/Brands/Brands";
import AddBrand from "../Pages/Brands/AddBrand";
import EditBrand from "../Pages/Brands/EditBrand";

import Categories from "../Pages/Categories/Categories";
import CategoriesTree from "../Pages/Categories/CategoriesTree";
import AddCategory from "../Pages/Categories/AddCategory";
import EditCategory from "../Pages/Categories/EditCategory";
import CategoryAttributes from "../Pages/Attributes/CategoryAttributes";
import AddCategoryAttribute from "../Pages/Attributes/AddCategoryAttribute";

import EditAttribute from "../Pages/Attributes/EditCategoryAttribute";
import AddValue from "../Pages/Values/AddValue";

import Customers from "../Pages/Customers/Customers";
import AddCustomer from "../Pages/Customers/AddCustomer";
import CustomerProfile from "../Pages/Customers/CustomerProfile";
import EditCustomer from "../Pages/Customers/EditCustomer";

import Orders from "../Pages/Orders/Orders";
import OrderDetails from "../Pages/Orders/OrderDetails";

import Stores from "../Pages/Stores/Stores";
import AddStore from "../Pages/Stores/AddStore";
import EditStore from "../Pages/Stores/EditStore";

import Shops from "../Pages/Shops/Shops";
import AddShop from "../Pages/Shops/AddShop";
import EditShop from "../Pages/Shops/EditShop";

import Roles from "../Pages/Roles/Roles";
import AddProduct from "../Pages/Products/AddProduct";
import ProductsPage from "../Pages/Products/ProductsPage";
import EditProduct from "../Pages/Products/EditProduct";

import Advertisements from "../Pages/Advertisements/Advertisements";
import AddAdvertisement from "../Pages/Advertisements/AddAdvertisement";
import EditAdvertisement from "../Pages/Advertisements/EditAdvertisement";

import EditValue from "../Pages/Values/EditValue";
import AddAddress from "../Pages/Addresses/AddAddress";
import EditAddress from "../Pages/Addresses/EditAddress";

import ProfitMargins from "../Pages/ProfitMargins/ProfitMargins";
import AddProfitMargin from "../Pages/ProfitMargins/AddProfitMargin";
import EditProfitMargin from "../Pages/ProfitMargins/EditProfitMargin";

import ProductImport from "../Pages/Imports/ProductImport";
import ProductsQuantityImport from "../Pages/Imports/ProductsQuantityImport";
import Sellers from "../Pages/Sellers/Sellers";
import AddSeller from "../Pages/Sellers/AddSeller";
import EditSeller from "../Pages/Sellers/EditSeller";

import Notifications from "../Pages/Notifications/Notifications";
import SeeNotification from "../Pages/Notifications/SeeNotification";
import Banners from "../Pages/Banners/Banners";
import EditBanner from "../Pages/Banners/EditBanner";

import Sliders from "../Pages/Sliders/Sliders";
import AddSlider from "../Pages/Sliders/AddSlider";
import EditSlider from "../Pages/Sliders/EditSlider";
import MainSliders from "../Pages/MainSlider/MainSliders";
import AddMainSlider from "../Pages/MainSlider/AddMainSlider";
import EditMainSlider from "../Pages/MainSlider/EditMainSlider";

import EditBestSellingProducts from "../Pages/BestSellingProducts/EditBestSellingProducts";
import DealOfTheDay from "../Pages/DealOfTheDay/DealOfTheDay";
import AddDealOfTheDay from "../Pages/DealOfTheDay/AddDealOfTheDay";
import EditDealOfTheDay from "../Pages/DealOfTheDay/EditDealOfTheDay";
import Settings from "../Pages/Settings/Settings";
import EditSetting from "../Pages/Settings/EditSetting";
import Pages from "../Pages/Pages/Pages";
import EditPage from "../Pages/Pages/EditPage";
import ResetPassword from "../Pages/Auth/ResetPassword";
import SendResetPasswordEmail from "../Pages/Auth/SendResetPasswordEmail";
import DeliveryPrices from "../Pages/DeliveryPrices/DeliveryPrices";
import AddDeliveryPrice from "../Pages/DeliveryPrices/AddDeliveryPrice";
import EditDeliveryPrice from "../Pages/DeliveryPrices/EditDeliveryPrice";
import AddPage from "../Pages/Pages/AddPage";
import EditContactInfos from "../Pages/ContactInfos/EditContactInfos";
import ProductPriceImport from "../Pages/Imports/ProductPriceImport";
import AccessForbidden from "../Pages/403";
import EditContinueShopping from "../Pages/ContinueShoppingProducts/EditContinueShopping";
import Coupons from "../Pages/Coupons/Coupons";
import AddCoupon from "../Pages/Coupons/AddCoupon";
import EditCoupon from "../Pages/Coupons/EditCoupon";
import CartItems from "../Pages/CartItems/CartItems";
import WishlistItems from "../Pages/WishlistItems/WishlistItems";
import SellerApplications from "../Pages/SellerApplications/SellerApplications";
import ViewSellerApplication from "../Pages/SellerApplications/ViewSellerApplication";
import CouponPromotionCart from "../Pages/CouponPromotions/CouponPromotionCart";
import CouponPromotionWishlist from "../Pages/CouponPromotions/CouponPromotionWishlist";
import ProductsImagesImport from "../Pages/Imports/ProductsImagesImport";
import ProductCategoryImport from "../Pages/Imports/ProductCategoryImport";
import ProductKeywordsImport from "../Pages/Imports/ProductKeywordsImport";
import ProductDiscountHistory from "../Pages/ProductDiscountHistory/ProductDiscountHistory";
import RecentOrders from "../Pages/Dashboard/RecentOrders";
import TopProducts from "../Pages/Dashboard/TopProducts";
import RecentFeedbacks from "../Pages/Dashboard/RecentFeedbacks";
import SalesByCategory from "../Pages/Dashboard/SalesByCategory";
import EditStaticPage from "../Pages/Seo/EditStaticPage";
import EditDynamicPage from "../Pages/Seo/EditDynamicPage";
import Seo from "../Pages/Seo/Seo";
import Profit from "../Pages/Dashboard/Profit";
import Refunds from "../Pages/Dashboard/Refunds";
import ProductAttributesImport from "../Pages/Imports/ProductAttributesImport";
import AddOrder from "../Pages/Orders/custom/AddOrder";
import NewEditOrder from "../Pages/Orders/edit/NewEditOrder";
import DeliveryInformation from "../Pages/DeliveryInformation/DeliveryInformation";
import EditCashbackRules from "../Pages/CashbackRules/EditCashbackRules";


export default function () {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/login" element={<Login/>}/>
        <Route exact path="/reset-password/:token/:email" element={<ResetPassword/>}/>
        <Route exact path="/send-reset-password-email/" element={<SendResetPasswordEmail/>}/>
        <Route path="/" element={<AppLayout/>}>
          <Route exact path="/" element={<ProtectedRoute Component={Main}/>}/>
          <Route exact path="/forbidden" element={<AccessForbidden/>}/>

          <Route exact path="/profile/edit" element={<ProtectedRoute Component={EditProfile}/>}/>

          <Route exact path="/dashboard"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={Dashboard}/>}/>
          <Route exact path="/dashboard/recent-orders"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={RecentOrders}/>}/>
          <Route exact path="/dashboard/top-products"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={TopProducts}/>}/>
          <Route exact path="/dashboard/recent-feedbacks"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={RecentFeedbacks}/>}/>
          <Route exact path="/dashboard/sales-by-category"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={SalesByCategory}/>}/>
          <Route exact path="/dashboard/profit"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={Profit}/>}/>
          <Route exact path="/dashboard/refunds"
                 element={<ProtectedRoute permission={'Dashboard View'} Component={Refunds}/>}/>

          <Route exact path="/feedbacks" permission={'Product Feedback View'}
                 element={<ProtectedRoute Component={Feedbacks}/>}/>

          <Route exact path="/admins" element={<ProtectedRoute permission={'User View'} Component={Admins}/>}/>
          <Route exact path="/admins/create" element={<ProtectedRoute permission={'User Add'} Component={AddAdmin}/>}/>
          <Route exact path="/admins/:id"
                 element={<ProtectedRoute permission={'User View'} Component={AdminProfile}/>}/>
          <Route exact path="/admins/:id/edit"
                 element={<ProtectedRoute permission={'User Edit'} Component={EditAdmin}/>}/>

          <Route exact path="/brands" element={<ProtectedRoute permission={'Brand View'} Component={Brands}/>}/>
          <Route exact path="/brands/create"
                 element={<ProtectedRoute permission={'Brand Add'} Component={AddBrand}/>}/>
          <Route exact path="/brands/:id/edit"
                 element={<ProtectedRoute permission={'Brand Edit'} Component={EditBrand}/>}/>

          <Route exact path="/categories"
                 element={<ProtectedRoute permission={'Category View'} Component={Categories}/>}/>
          <Route exact path="/categories/tree"
                 element={<ProtectedRoute permission={'Category View'} Component={CategoriesTree}/>}/>
          <Route exact path="/categories/create"
                 element={<ProtectedRoute permission={'Category Add'} Component={AddCategory}/>}/>
          <Route exact path="/categories/:id/edit"
                 element={<ProtectedRoute permission={'Category Edit'} Component={EditCategory}/>}/>
          <Route exact path="/categories/:id/attributes"
                 element={<ProtectedRoute permission={'Attribute View'} Component={CategoryAttributes}/>}/>
          <Route exact path="/categories/:id/attributes/create"
                 element={<ProtectedRoute permission={'Attribute Add'} Component={AddCategoryAttribute}/>}/>

          <Route exact path="/categories/:id/attributes/:attributeId/edit"
                 element={<ProtectedRoute permission={'Attribute Edit'} Component={EditAttribute}/>}/>
          <Route exact path="/attributes/:id/values/create"
                 element={<ProtectedRoute permission={'Attribute Add'} Component={AddValue}/>}/>

          <Route exact path="/customers"
                 element={<ProtectedRoute permission={'Customer View'} Component={Customers}/>}/>
          <Route exact path="/customers/create"
                 element={<ProtectedRoute permission={'Customer Add'} Component={AddCustomer}/>}/>
          <Route exact path="/customers/:id"
                 element={<ProtectedRoute permission={'Customer View'} Component={CustomerProfile}/>}/>
          <Route exact path="/customers/:id/edit"
                 element={<ProtectedRoute permission={'Customer Edit'} Component={EditCustomer}/>}/>

          <Route exact path="/orders/create"
                 element={<ProtectedRoute permission={'Order View'} Component={AddOrder}/>}/>
          <Route exact path="/orders/:id"
                 element={<ProtectedRoute permission={'Order View'} Component={OrderDetails}/>}/>
          <Route exact path="/orders/:id/edit"
                 element={<ProtectedRoute permission={'Order View'} Component={NewEditOrder}/>}/>
          <Route exact path="/orders" element={<ProtectedRoute permission={'Order View'} Component={Orders}/>}>
            <Route exact path="statuses/:status" element={<ProtectedRoute Component={Orders}/>}/>
          </Route>

          <Route exact path="/shops" element={<ProtectedRoute permission={'Shop View'} Component={Shops}/>}/>
          <Route exact path="/shops/create" element={<ProtectedRoute permission={'Shop Add'} Component={AddShop}/>}/>
          <Route exact path="/shops/:id/edit"
                 element={<ProtectedRoute permission={'Shop Edit'} Component={EditShop}/>}/>

          <Route exact path="/sellers" element={<ProtectedRoute accessRoles={['Seller']} Component={Sellers}/>}/>
          <Route exact path="/sellers/create"
                 element={<ProtectedRoute accessRoles={['Seller']} Component={AddSeller}/>}/>
          <Route exact path="/sellers/:id/edit"
                 element={<ProtectedRoute accessRoles={['Seller']} Component={EditSeller}/>}/>

          <Route exact path="/stores" element={<ProtectedRoute permission={'Store View'} Component={Stores}/>}/>
          <Route exact path="/stores/create"
                 element={<ProtectedRoute permission={'Store Add'} Component={AddStore}/>}/>
          <Route exact path="/stores/:id/edit"
                 element={<ProtectedRoute permission={'Store Edit'} Component={EditStore}/>}/>

          <Route exact path="/roles"
                 element={<ProtectedRoute permission={'Role View'} Component={Roles}/>}/>

          <Route exact path="/products/create"
                 element={<ProtectedRoute permission={'Product Add'} Component={AddProduct}/>}/>
          <Route exact path="/products"
                 element={<ProtectedRoute permission={'Product View'} Component={ProductsPage}/>}>
            <Route exact path=":status" element={<ProtectedRoute Component={ProductsPage}/>}/>
          </Route>
          <Route exact path="/products/:id/edit"
                 element={<ProtectedRoute permission={'Product Edit'} Component={EditProduct}/>}/>

          <Route exact path="/products/:id/discount-history"
                 element={<ProtectedRoute permission={'Product Discount History View'} Component={ProductDiscountHistory}/>}/>

          <Route exact path="/advertisements/create"
                 element={<ProtectedRoute permission={'Advertisement Add'} Component={AddAdvertisement}/>}/>
          <Route exact path="/advertisements/:id/edit"
                 element={<ProtectedRoute  permission={'Advertisement Edit'} Component={EditAdvertisement}/>}/>
          <Route exact path="/advertisements" element={<ProtectedRoute permission={'Advertisement View'} Component={Advertisements}/>}>
            <Route exact path=":status" element={<ProtectedRoute permission={'Advertisement View'} Component={Advertisements}/>}/>
          </Route>

          <Route exact path="/attributes/values/:id/edit"
                 element={<ProtectedRoute permission={'Attribute Edit'} Component={EditValue}/>}/>
          <Route exact path="/addresses/create/:id"
                 element={<ProtectedRoute permission={'Town Add'} Component={AddAddress}/>}/>
          <Route exact path="/addresses/:id/edit"
                 element={<ProtectedRoute permission={'Town Edit'} Component={EditAddress}/>}/>

          <Route exact path="/notifications" element={<ProtectedRoute Component={Notifications}/>}/>
          <Route exact path="/notifications/:id" element={<ProtectedRoute Component={SeeNotification}/>}/>

          <Route exact path="/profit-margins"
                 element={<ProtectedRoute permission={'Profit Margin View'} Component={ProfitMargins}/>}/>
          <Route exact path="/profit-margins/create"
                 element={<ProtectedRoute permission={'Profit Margin Add'} Component={AddProfitMargin}/>}/>
          <Route exact path="/profit-margins/:id/edit"
                 element={<ProtectedRoute permission={'Profit Margin Edit'} Component={EditProfitMargin}/>}/>

          <Route exact path="/imports/products"
                 element={<ProtectedRoute permission={'Import Products'} Component={ProductImport}/>}/>
          <Route exact path="/imports/products-quantity"
                 element={<ProtectedRoute permission={'Import Products Quantity'}
                                          Component={ProductsQuantityImport}/>}/>
          <Route exact path="/imports/prices"
                 element={<ProtectedRoute permission={'Import Products Prices'} Component={ProductPriceImport}/>}/>
          <Route exact path="/imports/images"
                 element={<ProtectedRoute permission={'Import Products Images'} Component={ProductsImagesImport}/>}/>
          <Route exact path="/imports/categories"
                 element={<ProtectedRoute permission={'Import Products Categories'} Component={ProductCategoryImport}/>}/>
          <Route exact path="/imports/keywords"
                 element={<ProtectedRoute permission={'Import Products Keywords'} Component={ProductKeywordsImport}/>}/>
          <Route exact path="/imports/product-attributes"
                 element={<ProtectedRoute permission={'Import Products Attributes'} Component={ProductAttributesImport}/>}/>

          <Route exact path="/banners" element={<ProtectedRoute permission={'Banner View'} Component={Banners}/>}/>
          <Route exact path="/banners/:id/edit"
                 element={<ProtectedRoute permission={'Banner Edit'} Component={EditBanner}/>}/>

          <Route exact path="/sliders" element={<ProtectedRoute permission={'Slider View'} Component={Sliders}/>}/>
          <Route exact path="/sliders/create"
                 element={<ProtectedRoute permission={'Slider Add'} Component={AddSlider}/>}/>
          <Route exact path="/sliders/:id/edit"
                 element={<ProtectedRoute permission={'Slider Edit'} Component={EditSlider}/>}/>

          <Route exact path="/best-selling-products"
                 element={<ProtectedRoute permission={'Best Selling Products View'}
                                          Component={EditBestSellingProducts}/>}/>

          <Route exact path="/continue-shopping"
                 element={<ProtectedRoute permission={'Continue Shopping View'}
                                          Component={EditContinueShopping}/>}/>

          <Route exact path="/deal-of-the-day"
                 element={<ProtectedRoute permission={'Deal Of The Day View'} Component={DealOfTheDay}/>}/>
          <Route exact path="/deal-of-the-day/create"
                 element={<ProtectedRoute permission={'Deal Of The Day Add'} Component={AddDealOfTheDay}/>}/>
          <Route exact path="/deal-of-the-day/:id/edit"
                 element={<ProtectedRoute permission={'Deal Of The Day Edit'} Component={EditDealOfTheDay}/>}/>

          <Route exact path="/cashback-rules"
                 element={<ProtectedRoute permission={'Cashback Rules View'} Component={EditCashbackRules}/>}/>

          <Route exact path="/main-sliders"
                 element={<ProtectedRoute permission={'Main Slider View'} Component={MainSliders}/>}/>
          <Route exact path="/main-sliders/create"
                 element={<ProtectedRoute permission={'Main Slider Add'} Component={AddMainSlider}/>}/>
          <Route exact path="/main-sliders/:id/edit"
                 element={<ProtectedRoute permission={'Main Slider Edit'} Component={EditMainSlider}/>}/>

          <Route exact path="/general-settings"
                 element={<ProtectedRoute permission={'General Settings View'} Component={Settings}/>}/>
          <Route exact path="/general-settings/:id/edit"
                 element={<ProtectedRoute permission={'General Settings View'} Component={EditSetting}/>}/>

          <Route exact path="/pages" element={<ProtectedRoute permission={'Page View'} Component={Pages}/>}/>
          <Route exact path="/pages/create" element={<ProtectedRoute permission={'Page Add'} Component={AddPage}/>}/>
          <Route exact path="/pages/:id/edit"
                 element={<ProtectedRoute permission={'Page Edit'} Component={EditPage}/>}/>

          <Route exact path="/delivery-prices"
                 element={<ProtectedRoute permission={'Delivery Price View'} Component={DeliveryPrices}/>}/>
          <Route exact path="/delivery-information"
                 element={<ProtectedRoute permission={'Delivery Price View'} Component={DeliveryInformation}/>}/>
          <Route exact path="/delivery-prices/create"
                 element={<ProtectedRoute permission={'Delivery Price Add'} Component={AddDeliveryPrice}/>}/>
          <Route exact path="/delivery-prices/:id/edit"
                 element={<ProtectedRoute permission={'Delivery Price Edit'} Component={EditDeliveryPrice}/>}/>

          <Route exact path="/contact-details"
                 element={<ProtectedRoute permission={'Contact Details View'} Component={EditContactInfos}/>}/>

          <Route exact path="/coupons" element={<ProtectedRoute permission={'Coupon View'} Component={Coupons}/>}/>
          <Route exact path="/coupons/create"
                 element={<ProtectedRoute permission={'Coupon Add'} Component={AddCoupon}/>}/>
          <Route exact path="/coupons/:id/edit"
                 element={<ProtectedRoute permission={'Coupon Edit'} Component={EditCoupon}/>}/>

          <Route exact path="/cart-items"
                 element={<ProtectedRoute permission={'Cart Items View'} Component={CartItems}/>}/>
          <Route exact path="/wishlist-items"
                 element={<ProtectedRoute permission={'Wishlist Items View'} Component={WishlistItems}/>}/>

          <Route exact path="/seller-applications"
                 element={<ProtectedRoute permission={'Seller Application View'} Component={SellerApplications}/>}/>
          <Route exact path="/seller-applications/:id"
                 element={<ProtectedRoute permission={'Seller Application View'} Component={ViewSellerApplication}/>}/>

          <Route exact path="/coupon-promotions/:productId/carts"
                 element={<ProtectedRoute permission={'Coupon Send'} Component={CouponPromotionCart}/>}/>
          <Route exact path="/coupon-promotions/:productId/wishlists"
                 element={<ProtectedRoute permission={'Coupon Send'} Component={CouponPromotionWishlist}/>}/>

          <Route exact path="/seo" element={<ProtectedRoute Component={Seo}/>}/>
          <Route exact path="/seo/static-pages/:id/edit"
                 element={<ProtectedRoute permission={'Page Edit'} Component={EditStaticPage}/>}/>
          <Route exact path="/seo/dynamic-pages/:id/edit"
                 element={<ProtectedRoute permission={'Static Page Edit'} Component={EditDynamicPage}/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}